/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tld: NonNullable<unknown> }} Tld_Pricing_Offered_OffInputs */

const id_tld_pricing_offered_off = /** @type {(inputs: Tld_Pricing_Offered_OffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tld} dinonaktifkan. Reseller tidak lagi melihatnya; pengaturan mereka tetap tersimpan.`)
};

const en_tld_pricing_offered_off = /** @type {(inputs: Tld_Pricing_Offered_OffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tld} is withdrawn. Resellers no longer see it; what they set is kept.`)
};

/**
* | output |
* | --- |
* | "{tld} is withdrawn. Resellers no longer see it; what they set is kept." |
*
* @param {Tld_Pricing_Offered_OffInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_offered_off = /** @type {((inputs: Tld_Pricing_Offered_OffInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Offered_OffInputs, { locale?: "id" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_offered_off(inputs)
	return id_tld_pricing_offered_off(inputs)
});